// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"767":"e823892d","968":"f53469cc","977":"51a205b2"}[chunkId] + ".chunk.css";
};